import { useEffect, useState } from "react";

import { fetchFeedbackFrame } from "./echoFeedbackClient";

type FeedbackFrameState =
  | { status: "idle" | "loading"; url: null; error: null }
  | { status: "ready"; url: string; error: null }
  | { status: "error"; url: null; error: string };

export function useFeedbackFrame(
  reportId: string | null | undefined,
  enabled: boolean,
): FeedbackFrameState {
  const [state, setState] = useState<FeedbackFrameState>({
    status: "idle",
    url: null,
    error: null,
  });

  useEffect(() => {
    if (!enabled || !reportId) {
      setState({ status: "idle", url: null, error: null });
      return;
    }

    let active = true;
    let objectUrl: string | null = null;
    setState({ status: "loading", url: null, error: null });
    fetchFeedbackFrame(reportId).then(
      (blob) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setState({ status: "ready", url: objectUrl, error: null });
      },
      (error) => {
        if (!active) return;
        setState({
          status: "error",
          url: null,
          error:
            error instanceof Error ? error.message : "Could not load frame",
        });
      },
    );

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [enabled, reportId]);

  return state;
}
